import React from 'react';

import { KeyboardArrowUpRounded } from '@material-ui/icons';
import { Zoom, useScrollTrigger, Fab, Box, Button, ButtonProps, CircularProgress } from '@material-ui/core';

import { Link } from './index';

export interface DownloadButtonProps {
  path?: Link;
  name?: string;
}

export interface ScrollToTopProps {
  scrollTarget?: HTMLElement | null;
}

export interface DynamicLoadingButtonProps extends Omit<ButtonProps, 'onClick'> {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<any>;
}

export const DownloadButton = (props: DownloadButtonProps) => {
  return (
    <a
      href={props.path}
      download={props.name} // Download only works on same-origin URLs; Otherwise file is opnened in new tab
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'inherit', textDecoration: 'none' }}
    >
      Herunterladen
    </a>
  );
};

export const ScrollToTop = (props: ScrollToTopProps) => {
  const triggered = useScrollTrigger({
    target: props.scrollTarget ? props.scrollTarget : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () =>
    props.scrollTarget?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

  return (
    <Zoom in={triggered}>
      <Box
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: '16px',
          right: '16px',
        }}
        role="presentation"
      >
        <Fab color="primary" aria-label="scroll back to top">
          <KeyboardArrowUpRounded />
        </Fab>
      </Box>
    </Zoom>
  );
};

export const DynamicLoadingButton = (props: DynamicLoadingButtonProps) => {
  const { onClick, children, ...rest } = props;

  const [loading, setLoading] = React.useState(false);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setLoading(true);
    // Dont set loading to false after click if promise resolved successfully
    // Component will be unmounted and loading state will be reset
    onClick?.(event).catch(() => setLoading(false));
  };

  return (
    <Button type="submit" {...rest} onClick={handleClick}>
      {loading ? <CircularProgress size={8} /> : children}
    </Button>
  );
};
